<template>
    <v-container id="buy_lp_form" :class="$vuetify.breakpoint.mdAndUp ? 'fixed-width' : 'pt-0'">
      <h2 class="pl-0 mb-6 ml-n3 text-h5" :class="{'d-none': !$vuetify.breakpoint.mdAndUp}">お申込みフォーム</h2>
      <form tabindex="0">

        <vb-form-section :title="sectionTitle1">
          <pickup-packages
            :max-number-of-packages="maxNumberOfPackages"
            :pickup-request-cut-off-time-offset-in-hours="pickupRequestCutOffTimeOffsetInHours"
            ref="pickupPackages"
          ></pickup-packages>
          <vb-coupon-code />
          <vb-support-group
            :form-items-setter="setBuyFormItems"
            :form-items-getter="{
              supportGroupId: getBuyFormItems.supportGroupId,
              supportGroupName: getBuyFormItems.supportGroupName,
              requestParamSupportGroupId: getBuyFormLabels.requestParamSupportGroupId
            }"
          />
        </vb-form-section>

        <vb-form-section :title="sectionTitle2">
          <vb-company-name
            :form-items-setter="setBuyFormItems"
            :form-items-getter="{companyName: getBuyFormItems.companyName}"
          />
          <vb-names
            :form-items-setter="setBuyFormItems"
            :form-items-getter="{
            firstname: getBuyFormItems.firstname,
            lastname: getBuyFormItems.lastname,
            firstnameKatakana: getBuyFormItems.firstnameKatakana,
            lastnameKatakana: getBuyFormItems.lastnameKatakana
          }"
          />
          <vb-birth-date
            :form-items-setter="setBuyFormItems"
            :form-labels-setter="setBuyFormLabels"
            :form-labels-getter="{
              birthdateYear: getBuyFormLabels.birthdateYear,
              birthdateMonth: getBuyFormLabels.birthdateMonth,
              birthdateDay: getBuyFormLabels.birthdateDay
            }"
          />
          <pickup-address
            :form-items-setter="setBuyFormItems"
            :form-items-getter="{
              postcode: getBuyFormItems.postcode,
              addressPrefecture: getBuyFormItems.addressPrefecture,
              addressLocal1: getBuyFormItems.addressLocal1,
              addressLocal2: getBuyFormItems.addressLocal2,
              isAddressSameAsSuggested: getIsAddressSameAsSuggested,
              supportGroupId: getBuyFormItems.supportGroupId,
            }"
            :form-labels-setter="setBuyFormLabels"
          />
          <vb-phone-number
            :form-items-setter="setBuyFormItems"
            :form-items-getter="{
              telephoneNumber1: getBuyFormItems.telephoneNumber1,
              telephoneNumber2: getBuyFormItems.telephoneNumber2,
              telephoneNumber3: getBuyFormItems.telephoneNumber3
            }"
          />
        </vb-form-section>

        <vb-form-section v-if="$route.name !== 'RegistrationCompleted'" :title="sectionTitle3">
          <slot name="mail-address"/>
          <slot name="email-subscription-for-charibon"/>
          <slot name="terms-of-service-for-charibon"/>
        </vb-form-section>

        <slot name="button"/>
      </form>
    </v-container>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import PickupPackages from "../organisms/buy/pickup-packages.vue";
import VbCouponCode from "../molecules/form/vb-coupon-code.vue";
import VbSupportGroup from "../molecules/form/vb-support-group.vue"
import PickupAddress from "../organisms/buy/pickup-address.vue";
import VbFormSection from "../organisms/buy/vb-form-section.vue";
import VbCompanyName from "../molecules/form/vb-company-name.vue";
import VbNames from "../molecules/form/vb-names.vue";
import VbBirthDate from "../molecules/form/vb-birth-date.vue";
import VbPhoneNumber from "../molecules/form/vb-phone-number.vue";
import VbMailAddress from "../molecules/form/vb-mail-address.vue";


export default {
  name: "register-form-charibon",
  components: {
    PickupPackages,
    VbCouponCode,
    VbSupportGroup,
    PickupAddress,
    VbFormSection,
    VbCompanyName,
    VbNames,
    VbBirthDate,
    VbPhoneNumber,
    VbMailAddress,
  },
  props: {
    pickupRequestCutOffTimeOffsetInHours: {
      type: Number,
      required: false,
      default: null,
    },
    maxNumberOfPackages: {
      type: Number,
      required: false,
      default: function () {
        return VueConfig.sell.maxNumberOfPackagesForCharibon;
      }
    },
    sectionTitle1: {
      type: String,
      required: false,
      default: 'お申込み内容',
    },
    sectionTitle2: {
      type: String,
      required: false,
      default: '集荷先情報',
    },
    sectionTitle3: {
      type: String,
      required: false,
      default: 'ご連絡先',
    },
  },
  inject: ['setErrors'],
  provide: function () {
    return {
      setErrors: this.setErrors
    }
  },
  methods: {
    ...mapActions({
      setMemberFormItems: 'member/updateFormItems',
      setBuyFormItems: 'buy/updateFormItems',
      setBuyFormLabels: 'buy/updateFormLabels',
    }),
  },
  computed: {
    ...mapGetters({
      getMemberFormItems: 'member/getFormItems',
      getBuyFormItems: 'buy/getFormItems',
      getBuyFormLabels: 'buy/getFormLabels',
      getIsAddressSameAsSuggested: "buy/isAddressSameAsSuggested"
    }),
  }
}
</script>

<style scoped lang="scss">
.fixed-width {
  max-width: 1024px;
}

.row {
  margin-top: 0;
  margin-bottom: 0;
}

// pick up address
.form-item-heading {
  white-space: nowrap;

  small {
    font-size: 10px;
    padding: 4px 0 0 5px;
  }
}

.caution-message {
  li {
    min-height: auto !important;
  }
}

::v-deep {
  .row {
    &.email-subscription {
      display: none;
    }
  }

  .row {
    margin-top: 0;
    margin-bottom: 0;
  }

  .v-messages__message {
    line-height: 1.2em;
  }

  .v-text-field__details {
    padding: 4px 0 0 !important;
  }

  // pick up address
  .v-input {
    input {
      background-color: transparent;
      border: 0 none;
    }

    &--is-focused, &--is-dirty {
      .accent2 {
        background-color: white !important;
      }
    }
  }

  .v-radio {
    label {
      color: rgba(0, 0, 0, 0.87);
    }
  }

  .tooltip-link {
    pointer-events: initial;
  }

  .v-text-field--outlined {
    fieldset {
      border-width: 1px !important;
    }

    &.v-input--has-state {
      fieldset {
        border-color: #9c9b98 !important;
      }
    }
  }

  .input-bg-white {
    fieldset {
      background-color: #FFF !important;
    }
  }

  // offer details
  #pickup-date-time-is-not-acceptable {
    margin: 0;
  }

  #sokufuri-recommendation-label {
    border-width: 2px;

    #sokufuri-recommendation-text::before {
      content: "\A";
      white-space: pre;
    }
  }

  .v-radio {
    label {
      color: rgba(0, 0, 0, 0.87);
    }

    align-items: flex-start;
  }

  .tooltip-link {
    pointer-events: initial;
  }

  // account
  .v-text-field--outlined {
    fieldset {
      border-width: 1px !important;
    }

    &.v-input--has-state {
      fieldset {
        border-color: #9c9b98 !important;
      }
    }
  }

  .input-bg-white {
    fieldset {
      background-color: #FFF !important;
    }
  }
}
</style>